import { post } from "../HttpService";

export class WorkingStatusService {
    static UpdateStatus = (queryData = {}, config = {}) => {
        return post(`device/device_working_status`, queryData, config);
    };
}
